import React, { useEffect, useState } from "react";
import close from "../../../assets/close.svg";
import "./VerificationModal.scss";
import VerificationInput from "../../verificationInput/VerificationInput";
import Button from "../../button/Button";
import { OTPVerification } from "../../../utilities/api/CustomerService";
interface VerificationModalProps {
  onClose: () => void;
  value: string;
  onResend: () => void;
  onSucess: () => void;
  requestID: string;
  onFailed: () => void;
}
const VerificationModal: React.FC<VerificationModalProps> = ({
  onClose,
  value,
  onResend,
  onSucess,
  requestID,
  onFailed,
}) => {
  const [otpSent, setOtpSent] = useState<boolean>(true);
  const [timer, setTimer] = useState<number>(120);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [code, setCode] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleComplete = (code: string) => {
    setCode(code);
  };

  useEffect(() => {
    let countdown: any = null;
    if (otpSent && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setResendDisabled(false);
    }

    return () => clearInterval(countdown);
  }, [otpSent, timer]);

  const handleResendOTP = () => {
    setOtpSent(true);
    setTimer(120);
    setResendDisabled(true);
    onResend();
  };
  return (
    <div className='modal'>
      <div className='modal-content'>
        <div className='close-cont'>
          <img alt='' src={close} className='close-ic' onClick={onClose} />
        </div>
        <div className='verification-content'>
          <div className='vc-head'>We’ve sent you a code!</div>
          <div className='vc-sub'>
            An OTP has sent to your <span className='vc-sub-spn'>{value}</span>.
            Please enter the code below to verify Your account
          </div>
        </div>
        <div className='veri-code'>
          <VerificationInput onComplete={handleComplete} />
        </div>
        <div className='rsnd-cde-cont'>
          {resendDisabled ? (
            <div className='resend-available'>
              <div className='head-rsn'>Resend available </div>
              <div className='resend-timer-text'>
                after <span className='resend-timer'>{timer}</span> seconds
              </div>
            </div>
          ) : (
            <div className='head-rsn'>
              Didn't receive the code?{" "}
              <span className='rsnd-txt' onClick={handleResendOTP}>
                Resend.{" "}
              </span>
            </div>
          )}
        </div>
        <div className='rsnd-btn-cont'>
          <Button
            text='Verify'
            onClick={() => {
              if (code.length === 6 && !isLoading) {
                setIsLoading(true);
                let data = {
                  RequestID: requestID,
                  OTP: code,
                };
                OTPVerification(data).then((response) => {
                  if (response === "Success") {
                    onSucess();
                  } else {
                    setIsLoading(false);
                    onFailed();
                  }
                });
              }
            }}
            isPrimary
            isDisable={code === ""}
            isLoading={isLoading}
          />
          <div className='empty-mrg' />
          <Button text='Cancel' onClick={onClose} isPrimary={false} />
        </div>
      </div>
    </div>
  );
};
export default VerificationModal;
